import { render, staticRenderFns } from "./editform.vue?vue&type=template&id=01549a5e&scoped=true"
import script from "./editform.vue?vue&type=script&lang=js"
export * from "./editform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01549a5e",
  null
  
)

export default component.exports